import * as React from "react";
import { forwardRef } from "react";
const SvgChevronUp = (props, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M6 13.59L7.41 15L12 10.42L16.59 15L18 13.59L12 7.59L6 13.59Z", fill: "currentcolor" }));
const ForwardRef = forwardRef(SvgChevronUp);
export default ForwardRef;
